import { useTranslation } from 'react-i18next';

import male from 'assets/img/draws/male.webp';
import female from 'assets/img/draws/female.webp';

import { IContentCardConfig } from 'types/pages/startPages/commonTypes';

export const getContent = (): IContentCardConfig => {
    const { t } = useTranslation();

    return {
        pageTitles: {
            firstTitle: t('startFlow.startUnisex.title'),
            secondTitle: t('startFlow.startUnisex.subtitle'),
        },

        cardsData: [
            {
                value: 'male',
                img: male,
                title: t('startFlow.startUnisex.firstOption'),
                buttonColor: 'decorativeMale',
                dataLocator: 'startMaleBtn',
            },
            {
                value: 'female',
                img: female,
                title: t('startFlow.startUnisex.secondOption'),
                dataLocator: 'startFemaleBtn',
            },
        ],
    };
};
